// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__9D56D","pageNumber":"Paginator_pageNumber__dwIC5","selectedPage":"Paginator_selectedPage__IcEa8"};